import React from 'react';
import PropTypes from 'prop-types';
import Check from '@material-ui/icons/Check';
import useStyles from './copy-feedback.styles';

export default function CopyFeedback({ copied, icon, className }) {
  const classes = useStyles();
  return (
    <span className={classes.root} data-state={copied ? 'copied' : 'idle'}>
      <img className={className || classes.icon} src={icon} alt="" aria-hidden="true" />
      <Check className={classes.check} aria-hidden="true" />
      <span role="status" className={classes.status}>
        {copied ? 'Copied' : ''}
      </span>
    </span>
  );
}

CopyFeedback.propTypes = {
  copied: PropTypes.bool.isRequired,
  icon: PropTypes.string.isRequired,
  className: PropTypes.string
};
